import { isNonNaNNumber } from '@iotv/iotv-v3-types'

/** renamed export of isNonNaNNumber from types, tests that is number, ie not NaN, undefined or null */
export const isNumber = isNonNaNNumber
